import { render, staticRenderFns } from "./DepartInfo.vue?vue&type=template&id=b2d7891a&scoped=true&"
import script from "./DepartInfo.vue?vue&type=script&lang=js&"
export * from "./DepartInfo.vue?vue&type=script&lang=js&"
import style0 from "./DepartInfo.vue?vue&type=style&index=0&id=b2d7891a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d7891a",
  null
  
)

export default component.exports